type ConnectionInfo = { effectiveType?: string; downlink?: number; rtt?: number };

const getConnection = (): ConnectionInfo | undefined =>
  (navigator as Navigator & { connection?: ConnectionInfo }).connection;

/**
 * How long to wait for an embedded app before calling the load a failure.
 *
 * A slow link legitimately needs longer. `navigator.connection` is Chromium-only, so the 10s
 * default is what most browsers get.
 */
export const getLoadTimeoutMs = () => {
  const effectiveType = getConnection()?.effectiveType;
  if (effectiveType === 'slow-2g' || effectiveType === '2g') return 25_000;
  if (effectiveType === '3g') return 20_000;
  return 10_000;
};

/**
 * Network conditions to attach to a load-failure log.
 *
 * Carries no identifiers: connection shape and online state only, nothing drawn from the player's
 * profile or the embedded app's URL.
 */
export const getConnectionDiagnostics = () => {
  const conn = getConnection();

  return {
    connection: conn ? { effectiveType: conn.effectiveType, downlink: conn.downlink, rtt: conn.rtt } : 'unavailable',
    online: navigator.onLine,
  };
};
